import { useQuery } from "react-query";
import { getFilteredHierarchies } from "actions/CarrierAgreementMgmt/Hierarchy";

const useFilteredHierarchies = ({ filterInputData, enableSearch = false }) => {
  return useQuery(
    ["FilteredHierarchies", filterInputData],
    getFilteredHierarchies,
    {
      enabled: enableSearch,
    }
  );
};

export default useFilteredHierarchies;
